import { Box, Button, Loader, TextButton, Tooltip } from '@wix/design-system';
import { SparklesSmall } from '@wix/wix-ui-icons-common';
import React from 'react';
import { dataHooks } from '../../../../../../utils/datahooks';
export const FixWithAiButton = _ref => {
  let {
    disabled,
    isLoading,
    onClick,
    onCancel,
    dataHook,
    texts
  } = _ref;
  if (!texts) {
    return null;
  }
  const {
    buttonLabel,
    disabledTooltip,
    cancelLabel
  } = texts;
  return /*#__PURE__*/React.createElement(Box, {
    align: "center",
    gap: "SP2"
  }, /*#__PURE__*/React.createElement(Tooltip, {
    content: disabledTooltip,
    disabled: !disabled || isLoading,
    maxWidth: 204,
    size: "small",
    inline: true
  }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Button, {
    dataHook: dataHook,
    disabled: disabled || isLoading,
    gap: "SP1",
    prefixIcon: /*#__PURE__*/React.createElement(Box, {
      margin: "0 4px 0 -6px"
    }, isLoading ? /*#__PURE__*/React.createElement(Box, {
      paddingRight: "2px"
    }, /*#__PURE__*/React.createElement(Loader, {
      size: "tiny"
    })) : /*#__PURE__*/React.createElement(SparklesSmall, null)),
    priority: "secondary",
    size: "tiny",
    weight: "thin",
    onClick: onClick
  }, buttonLabel))), isLoading && /*#__PURE__*/React.createElement(Box, {
    marginTop: "2px"
  }, /*#__PURE__*/React.createElement(TextButton, {
    dataHook: dataHook ? dataHooks.fixWithAiButtonCancel(dataHook) : undefined,
    size: "tiny",
    skin: "dark",
    underline: "always",
    onClick: onCancel
  }, cancelLabel)));
};
//# sourceMappingURL=fix-with-ai-button.js.map